import usePdpAtom from '../usePDPAtom';
const DEFAULT_VALUE = {};
const usePdpLastHoveredOptionsExtendedAtom = () => {
  const pdpLastHoveredOptionsExtendedAtom = usePdpAtom("pdpLastHoveredOptionsExtendedAtom", DEFAULT_VALUE);
  return pdpLastHoveredOptionsExtendedAtom;
};
export default usePdpLastHoveredOptionsExtendedAtom;